// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"041b429b","832":"7225d7e0"}[chunkId] + ".chunk.js";
};